<template>
  <div class="home">
    <!-- 移动端：专家角色 -->
    <mob-wrap :userName="loginInfo.userName" v-if="isMob" />
    
    <!-- PC端：采购人和监管部门 -->
    <pc-wrap v-else />
  </div>
</template>
<script>
import { mapState } from "vuex";
import MobWrap from "content/mobWrap";
import PcWrap from "content/pcWrap";

export default {
  components: {
    MobWrap,
    PcWrap,
  },
  data() {
    return {};
  },
  computed: {
    // 根据用户角色，判断是移动页面还是PC页面
    ...mapState(["loginInfo"]),
    isMob() {
      return this.loginInfo.roleId == 4;
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  height: 100%;
}
</style>